import React, { Component } from "react";
import { Globals } from "../constants";
import Login from "../Login";

import { Helmet } from "react-helmet";

class FantasyView extends Component {
  constructor(props) {
    super(props);
    this.xAccessToken = JSON.parse(localStorage.getItem("user"))
      ? JSON.parse(localStorage.getItem("user")).xAccessToken
      : "";
    this.xAccessToken = window.btoa(this.xAccessToken); // bas64 encoding
    this.msisdn = JSON.parse(localStorage.getItem("user"))
      ? JSON.parse(localStorage.getItem("user")).phone
      : "";

    this.fantasyVerificationURL =
      "https://fantasy.cricwick.net/authentication/";

    this.fantasyVerificationURL =
      this.fantasyVerificationURL +
      this.xAccessToken +
      "/" +
      this.msisdn +
      `${window.location.search}#utm_source=` +
      Globals.appName +
      `&utm_medium=web&utm_campaign=MyStars11`;
  }

  render() {
    return this.msisdn &&
      this.msisdn.length > 0 &&
      this.xAccessToken &&
      this.xAccessToken.length > 0 ? (
      <div
        id="main-section"
        className="holds-the-iframe"
        style={{ backgroundColor: "#FFFFFF", zIndex: "0" }}
      >
        <Helmet>
          <link
            rel="canonical"
            href={window.location.href.replace("www.", "")}
          />

          <title>
            Play PSL Fantasy League for free and Win Exciting Cash Prizes -
            CricWick
          </title>
          <meta
            name="description"
            content={
              "Play PSL Fantasy League for free. Create your team today, beat the competition and win exciting cash prizes on MyStars11, only on CricWick"
            }
          />
        </Helmet>
        <iframe
          title="fantasy"
          src={this.fantasyVerificationURL}
          style={{ width: "100%", height: "1080px" }}
          frameBorder="0"
        />
      </div>
    ) : (
      <Login />
    );
  }
}

export default FantasyView;
